// src/pages/News.js
import React, { useState, useEffect } from "react";
import AdminNews from "../Admin/AdminNews.js"; // AdminNews-Komponente importieren
import "../Admin/WinterTemplate.css"; // Beispiel für weiteres Template
import "../Admin/AutumnTemplate.css";
import "../Admin/SummerTemplate.css";
import useEventStore from "../stores/EventStore.js";
import DateVoting from "../components/EventDateVoting.js";
import EventVoting from "../components/EventVoting.js";
import EventDateAdminPage from "../components/EventDateAdminPage.js";
import EventVoteAdminPage from "../components/EventVoteAdminPage.js";
import { useNavigate } from 'react-router-dom';
import { auth } from '../Admin/Api.js';

const News = () => {
  const [role, setRole] = useState(null);
  const { getEventInformation, eventInformation,
    getAllEventDatesVoted, getDateVoteCounts, isFinalEventDatePresent
    , getFinalEventDate, dateToVote } = useEventStore(); // Importiere die Funktion aus dem EventContext
  const navigate = useNavigate();


  useEffect(() => {
    auth().then(isAuth => {
      if (!isAuth) {
        handleLogout()
      }
    });
  }, [navigate]);

  const handleLogout = () => {
    // Alle Daten aus localStorage entfernen und den Login-Status zurücksetzen
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    localStorage.removeItem('userId'); // Optional, falls du die User-ID im LocalStorage speicherst

    // Benutzer zum Login weiterleiten
    navigate("/login");
  };

  useEffect(() => {
    const init = async () => {
      const userRole = localStorage.getItem("role");
      const name = localStorage.getItem("username");

      setRole(userRole || "");
      getEventInformation();

      const finalEvent = await getFinalEventDate(); // Warten auf Ergebnis
      if (!isFinalEventDatePresent.isPresent) {
        getAllEventDatesVoted(name);
        getDateVoteCounts();
      }

      const interval = setInterval(async () => {
        try {
          //console.log("interval called")
          getEventInformation();
          getFinalEventDate(); // Warten auf Ergebnis
          console.log(isFinalEventDatePresent)
          if (!isFinalEventDatePresent.isPresent) {
            getAllEventDatesVoted(name);
            getDateVoteCounts();
          }
        } catch (error) {
          console.error("Fehler beim Abrufen der Anwesenheitsliste:", error);
        }
      }, 30000); // polls every 30 seconds

      return () => clearInterval(interval);
    };
    init();
  }, []);

  return (
    <div className={`news-container ${eventInformation.template}`}>
      <div className="news-box">
        <h2>{eventInformation.headline || "Es gibt momentan keine Neuigkeiten"}</h2>
        <div>
          {eventInformation && eventInformation.news
            ? eventInformation.news.split("\n").map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))
            : <p></p>
            }
        </div>

        <div className="date-voting">
          {isFinalEventDatePresent ? (
            <EventVoting />
          ) : (
            <DateVoting />
          )}
        </div>
      </div>
      {role === "ADMIN" && (
        <div className="admin-section">
          <div className="admin-section">
            {role === "ADMIN" && <AdminNews />}
          </div>
          {isFinalEventDatePresent ? (
            <EventVoteAdminPage />
          ) : (
            <EventDateAdminPage />
          )}
        </div>
      )}

    </div>
  );
};

export default News;